import React, { useEffect, useMemo } from "react";

const ImageBox = {
  width: "100%",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  paddingTop: "2rem",
  marginTop: "1rem",
};

const image = {
  margin: "auto",
};

function Image(props) {
  const url = useMemo(() => {
    return props.link || props.location?.useProps?.fileUrl || props.fileUrl;
  }, [props]);
  useEffect(() => {
    if (props?.location?.useProps?.click) {
      props.location.useProps.click();
    }
  }, []);
  return (
    <div style={ImageBox}>
      <img style={image} src={url} alt={url} />
    </div>
  );
}

export default Image;
